import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercard = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25.9 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#D90010",
			d: "M9.9,8c0-2.4,1.1-4.8,3-6.3C9.5-1,4.5-0.4,1.7,3S-0.4,11.5,3,14.3c2.9,2.3,7,2.3,9.9,0C11,12.8,9.9,10.4,9.9,8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#E54800",
			d: "M9.9,8c0,2.4,1.1,4.8,3,6.3C16.4,11.5,17,6.5,14.3,3c-0.4-0.5-0.8-0.9-1.3-1.3C11,3.2,9.9,5.6,9.9,8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F78B00",
			d: "M17.9,0c-1.8,0-3.6,0.6-5,1.7c3.5,2.7,4,7.8,1.3,11.2c-0.4,0.5-0.8,0.9-1.3,1.3c3.5,2.7,8.5,2.2,11.2-1.3s2.2-8.5-1.3-11.2C21.5,0.6,19.7,0,17.9,0"
		})
	]
});
export { SvgMastercard as ReactComponent };
